/**
 * LiveKit data-channel notifications for host moderation.
 * Server RoomService is the source of truth; this is UX only.
 */

export const HOST_MODERATION_TYPE = "host_moderation";

export type HostModerationMessage = {
  v: 1;
  type: typeof HOST_MODERATION_TYPE;
  action:
    | "mute"
    | "unmute"
    | "remove"
    | "admit"
    | "hold"
    | "promote"
    | "demote";
  identity: string; // participant id, or "*" for room-wide bulk actions
  track_source?: string;
  at: number;
};
